import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";

// Custom SweetAlert for error messages
export const showErrorAlert = ({
  title = "Error",
  text,
  icon = "error",
  confirmButtonText = "OK",
  confirmButtonColor = "#d33",
  callback,
}) => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: confirmButtonText,
    confirmButtonColor: confirmButtonColor,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showClass: {
      popup: "animate__animated animate__fadeInUp animate__faster",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutDown animate__faster",
    },
  }).then((result) => {
    // Execute callback if needed after confirmation
    if (result.isConfirmed && callback) {
      callback();
    }
  });
};
